import Vue from "vue";

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsOpen", true);
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "detailsFormIsOpen", false);
        Vue.set(state, "detailsGridIsOpen", false);
    },
    setFormOpen(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
        state.detailsFormIsOpen = false;
        state.detailsGridIsOpen = false;
    },
    setFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
        state.detailsFormIsOpen = false;
        state.detailsGridIsOpen = false;
    },
    setDetailFormOpen(state) {
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.detailsFormIsOpen = true;
        state.detailsGridIsOpen = false;
    },
    setDetailGridOpen(state) {
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.detailsFormIsOpen = false;
        state.detailsGridIsOpen = true;
    }
}
